import { render, staticRenderFns } from "./GalleryViewGrid.vue?vue&type=template&id=1ef677b6"
import script from "./GalleryViewGrid.vue?vue&type=script&lang=ts"
export * from "./GalleryViewGrid.vue?vue&type=script&lang=ts"
import style0 from "./GalleryViewGrid.vue?vue&type=style&index=0&id=1ef677b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports